import {
  all, call, put, select, takeLatest, delay,
} from 'redux-saga/effects';
import { message } from 'antd';
import {
  COMERCIA_AUTHORIZE_API_FAILURE,
  COMERCIA_AUTHORIZE_API_REQUEST,
  COMERCIA_AUTHORIZE_API_SUCCESS,
  COMERCIA_COMPLETE_API_FAILURE,
  COMERCIA_COMPLETE_API_REQUEST,
  COMERCIA_COMPLETE_API_SUCCESS,
  COMERCIA_IS_AVALIABLE_API_FAILURE,
  COMERCIA_IS_AVALIABLE_API_REQUEST,
  COMERCIA_IS_AVALIABLE_API_SUCCESS,
  COMERCIA_NEW_TRANSACTION_FAILURE,
  COMERCIA_NEW_TRANSACTION_REQUEST,
  COMERCIA_NEW_TRANSACTION_SUCCESS,
  COMERCIA_REBATE_API_FAILURE,
  COMERCIA_REBATE_API_REQUEST,
  COMERCIA_REBATE_API_SUCCESS,
  LAUNCH_COMERCIA_AUTHORIZE,
  LAUNCH_COMERCIA_COMPLETE,
  LAUNCH_COMERCIA_IS_AVALIABLE,
  LAUNCH_COMERCIA_REBATE,
} from '../actions/constants/comercia.datafono.constants';
import { externalRequest } from '../../helpers/request.helper';

const TRANSACTION_RESPONSE_ESTATUS_OK = ['090', '091', '092', '096', '097', '098', '099'];

function apiDatafonoRequestHtml({
  method, url,
}) {
  const apiURL = url;
  const fetchOptions = {
    method,
  };
  return new Promise((resolve, reject) => fetch(apiURL, fetchOptions)
    .then(response => (response.status !== 200 ? reject(response) : response))
    .then(response => resolve(response))
    .catch((error) => { reject(error); console.error(error); }));
}
function apiDatafonoRequestJson({
  method, url, headers, body,
}) {
  const apiURL = url;
  const fetchOptions = {
    method,
    body,
    headers,
  };
  return new Promise((resolve, reject) => fetch(apiURL, fetchOptions)
    .then(response => (response.status !== 200 && response.status !== 400 ? reject(response) : response.json()))
    .then(response => resolve(response))
    .catch((error) => { reject(error); console.error(error); }));
}
function* updateApi(data) {
  for (let i = 0; i < 5; i += 1) {
    try {
      return yield call(apiDatafonoRequestHtml, data);
    } catch (err) {
      if (i < 4) {
        yield delay(2000);
      }
    }
  }
  // attempts failed after 5 attempts
  throw new Error('API request failed');
}
function* updateApiTillOk(data) {
  let response = null;
  let i = 0;
  while (i < 120000 && (!response || (response.data && response.data.isOK && !TRANSACTION_RESPONSE_ESTATUS_OK.includes(response.data.responseCode)))) {
    try {
      response = yield call(externalRequest, data);
      yield delay(2000);
    } catch (err) {
      yield delay(2000);
    }
    i += 2000;
  }
  if (response && response.data) {
    return response;
  }
  // attempts failed after 5 attempts
  throw new Error('API request failed');
}
function* isAvaliableApiRequest({ payload }) {
  try {
    yield put({
      type: COMERCIA_IS_AVALIABLE_API_REQUEST,
      payload,
    });
    const url = 'http://localhost:5000/swagger/index.html';
    const requestParams = {
      url,
      method: 'GET',
    };
    const response = yield call(updateApi, requestParams);
    yield put({
      type: COMERCIA_IS_AVALIABLE_API_SUCCESS,
      payload: response,
    });
  } catch (ex) {
    yield put({ type: COMERCIA_IS_AVALIABLE_API_FAILURE });
    //message.error('Ocurrió un error al comprobar la disponibilidad del datafono');
    throw new Error(COMERCIA_IS_AVALIABLE_API_FAILURE);
  }
}
function* authorizeApiRequest({ payload }) {
  const { amount, currency = 'EUR', trxTimeOut = 90 } = payload;
  let response = null;
  try {
    yield put({
      type: COMERCIA_AUTHORIZE_API_REQUEST,
      payload,
    });
    const url = 'http://localhost:5000/api/v1/Authorisation';
    const orderId = new Date().getTime();
    const jsonData = JSON.stringify({
      identificationData: {
        orderId,
        referenceNumber: orderId,
      },
      paymentInformation: {
        externalCardData: null,
        currency,
        amount,
      },
      trxTimeOut,
    });
    const requestParams = {
      url,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: jsonData,
    };
    response = yield call(updateApiTillOk, requestParams);
    if (!response.data.isOK || !TRANSACTION_RESPONSE_ESTATUS_OK.includes(response.data.responseCode)) {
      throw new Error(COMERCIA_AUTHORIZE_API_FAILURE);
    }
    yield put({
      type: COMERCIA_AUTHORIZE_API_SUCCESS,
      payload: { orderId, response },
    });
    return orderId;
  } catch (ex) {
    yield put({ type: COMERCIA_AUTHORIZE_API_FAILURE, payload: response });
    //message.error('Ocurrió un error al autorizar el datafono');
    throw new Error(COMERCIA_AUTHORIZE_API_FAILURE);
  }
}
function* rebateApiRequest({ payload }) {
  const {
    amount, currency = 'EUR', trxTimeOut = 90, transactionId,
  } = payload;
  try {
    yield put({
      type: COMERCIA_REBATE_API_REQUEST,
      payload,
    });
    const url = `http://localhost:5000/api/v1/Rebate/${transactionId}`;
    const orderId = new Date().getTime();
    const jsonData = JSON.stringify({
      identificationData: {
        orderId,
        referenceNumber: orderId,
      },
      paymentInformation: {
        externalCardData: null,
        currency,
        amount,
      },
      trxTimeOut,
    });
    const requestParams = {
      url,
      method: 'POST',
      body: jsonData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(updateApiTillOk, requestParams);
    if (!response.data.isOK || !TRANSACTION_RESPONSE_ESTATUS_OK.includes(response.data.responseCode)) {
      throw new Error(COMERCIA_REBATE_API_FAILURE);
    }
    yield put({
      type: COMERCIA_REBATE_API_SUCCESS,
      payload: { orderId, response },
    });
    return orderId;
  } catch (ex) {
    yield put({ type: COMERCIA_REBATE_API_FAILURE });
    //message.error('Ocurrió un error al autorizar el datafono');
    throw new Error(COMERCIA_REBATE_API_FAILURE);
  }
}
function* completeApiRequest({ payload }) {
  const { orderId } = payload;
  try {
    yield put({
      type: COMERCIA_COMPLETE_API_REQUEST,
      payload,
    });
    const url = 'http://localhost:5000/api/v1/Complete';
    const jsonData = JSON.stringify({
      identificationData: {
        orderId,
        referenceNumber: orderId,
      },
      ticketWasPrinted: true,
    });
    const requestParams = {
      url,
      method: 'POST',
      body: jsonData,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    const response = yield call(externalRequest, requestParams);
    yield put({
      type: COMERCIA_COMPLETE_API_SUCCESS,
      payload: response,
    });
    return response;
  } catch (ex) {
    yield put({ type: COMERCIA_COMPLETE_API_FAILURE });
    //message.error('Ocurrió un error al completar la transaccion');
    throw new Error(COMERCIA_COMPLETE_API_FAILURE);
  }
}
function* newTransactionRequest({ payload }) {
  try {
    const { mode = 'payment' } = payload;
    yield call(isAvaliableApiRequest, { payload });
    let orderId = null;
    if (mode === 'refund') {
      orderId = yield call(rebateApiRequest, { payload });
    } else {
      orderId = yield call(authorizeApiRequest, { payload });
    }
    const response = yield call(completeApiRequest, { payload: { orderId } });
    response.orderId = orderId;
    yield put({
      type: COMERCIA_NEW_TRANSACTION_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: COMERCIA_NEW_TRANSACTION_FAILURE, payload: e });
  }
}
function* comerciaDatafonoSaga() {
  yield all([
    takeLatest(COMERCIA_NEW_TRANSACTION_REQUEST, newTransactionRequest),
    takeLatest(LAUNCH_COMERCIA_IS_AVALIABLE, isAvaliableApiRequest),
    takeLatest(LAUNCH_COMERCIA_AUTHORIZE, authorizeApiRequest),
    takeLatest(LAUNCH_COMERCIA_REBATE, rebateApiRequest),
    takeLatest(LAUNCH_COMERCIA_COMPLETE, completeApiRequest),
  ]);
}

export default comerciaDatafonoSaga;
